import { Component } from 'react';
import { Route } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export class NotFoundComponent extends Component {
  // just for test purpose
  static data = `The Page You Were Looking For Was Not Found`;
  render() {
    return /*#__PURE__*/_jsx(Route, {
      render: _ref => {
        let {
          staticContext
        } = _ref;
        if (staticContext) staticContext.statusCode = 404;
        return NotFoundComponent.data;
      }
    });
  }
}